'use client';

import dynamic from 'next/dynamic';

// Swiper is ~76 KiB — wrap in a client component so `ssr: false` is
// allowed and the chunk is only fetched when a listing actually uses
// the slider rendering mode.
const GallerySlider = dynamic(
  () =>
    import('./gallery-slider').then(mod => ({
      default: mod.GallerySlider,
    })),
  { ssr: false },
);

export { GallerySlider as LazyGallerySlider };
